var React = require('react');

function IcPdf (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 2h12c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2zm0 14h12V4H8v12zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm12 3v3c0 .55-.45 1-1 1h-2V8h2c.55 0 1 .45 1 1zm-2 0h1v3h-1V9zm5 2h-1v2h-1V8h2v1h-1v1h1v1zm-9 0h1c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H9v5h1v-2zm1-2h-1v1h1V9z","fill":"currentColor"}));
}

IcPdf.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IcPdf;

IcPdf.default = IcPdf;
